export default "__VITE_ASSET__1bf01719__"